import React, { useState } from "react";
import { toast } from "react-toastify";
import DocumentMeta from "react-document-meta";
import { Button } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";

import LeftTab from "../Common/LeftTab";
import {
  useGetAddressQuery,
  useAddAddressMutation,
  useDeleteAddressMutation,
  useGetChainsQuery,
} from "../../redux/whiteListApi";

const meta = {
  title: "Whitelist | Green Crypto Exchange",
  description: "Green Crypto Exchange for fast and secure crypto trading.",
  canonical: "https://Green Crypto.com",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "Crypto Exchange, Whitelist Wallet, BTC ETH Wallet",
    },
  },
};

const WhitelistFunction = () => {
  const [form, setForm] = useState({ coinType: "", walletAddress: "" });
  const [formErrors, setFormErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);

  const { data: chainsData } = useGetChainsQuery();
  const { data: addressData, refetch } = useGetAddressQuery();
  const [addAddress] = useAddAddressMutation();
  const [deleteAddress] = useDeleteAddressMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // validate as user types/changes
    setFormErrors((prev) => {
      const updatedErrors = { ...prev };

      if (name === "coinType") {
        if (!value || value === "Select") {
          updatedErrors.coinType = "This field is required";
        } else {
          delete updatedErrors.coinType;
        }
      }

      if (name === "walletAddress") {
        if (!value) {
          updatedErrors.walletAddress = "This field is required";
        } else if (value.includes(" ")) {
          updatedErrors.walletAddress = "Wallet address cannot contain spaces";
        }
        // else if (value.length < 26 || value.length > 64) {
        //   updatedErrors.walletAddress = "Wallet address length must be 26–64 characters";
        // }
        else {
          delete updatedErrors.walletAddress;
        }
      }

      return updatedErrors;
    });
  };

  const validateForm = () => {
    const { coinType, walletAddress } = form;
    const errors = {};

    if (!coinType || coinType === "Select") {
      errors.coinType = "This field is required";
    }

    if (!walletAddress) {
      errors.walletAddress = "This field is required";
    } else if (walletAddress.includes(" ")) {
      errors.walletAddress = "Wallet address cannot contain spaces";
    }
    // else if (walletAddress.length < 26 || walletAddress.length > 64) {
    //   errors.walletAddress = "Wallet address length must be 26–64 characters";
    // }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setBtnDisabled(true);
    toast.dismiss();

    try {
      const payload = {
        chain_id: +form.coinType,
        wallet_address: form.walletAddress,
      };

      const { data, error } = await addAddress(payload);

      if (data?.status) {
        toast.success(data?.message || "Address added successfully");
        setForm({ coinType: "", walletAddress: "" });
        refetch();
      } else {
        toast.error(error.data.message || "Failed to add address");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setBtnDisabled(false);
    }
  };

  const handleDelete = (id) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this address?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const { data } = await deleteAddress({ address_id: id });
              if (data?.status) {
                toast.success(data.message || "Address deleted");
                refetch();
              } else {
                toast.error(data.message || "Failed to delete");
              }
            } catch (err) {
              toast.error("Something went wrong");
            }
          },
        },
        { label: "No" },
      ],
    });
  };

  return (
    <div>
      <DocumentMeta {...meta}>
        <div className="bghwhite">
          <div className="new_inpage">
            <div className="container container2">
              <LeftTab />
              <h5>Whitelist</h5>
              <div className="wishlist-main-outer">
                <div className="row">
                  {/* Form */}
                  <div className="col-md-4">
                    <div className="wishlist-left">
                      <p className="mt-0">
                        Whitelist is a security feature allowing withdrawals
                        only to approved wallet addresses.
                      </p>

                      <div className="wishlist-form">
                        {/* Coin Dropdown */}
                        <div className="form-group">
                          <label>Cryptocoin</label>
                          <select
                            name="coinType"
                            className={`form-control ${
                              formErrors.coinType ? "is-invalid" : ""
                            }`}
                            value={form.coinType}
                            onChange={handleChange}
                          >
                            <option value="">Select</option>
                            {chainsData?.data?.map((coin) => (
                              <option key={coin.chainId} value={coin.chainId}>
                                {coin.chainSymbol}
                              </option>
                            ))}
                          </select>
                          {formErrors.coinType && (
                            <div className="text-danger">
                              {formErrors.coinType}
                            </div>
                          )}
                        </div>

                        {/* Wallet Address */}
                        <div className="form-group mt-2">
                          <label>Wallet Address</label>
                          <input
                            className={`form-control ${
                              formErrors.walletAddress ? "is-invalid" : ""
                            }`}
                            placeholder="Enter wallet address"
                            name="walletAddress"
                            value={form.walletAddress}
                            onChange={handleChange}
                          />
                          {formErrors.walletAddress && (
                            <div className="text-danger">
                              {formErrors.walletAddress}
                            </div>
                          )}
                        </div>

                        <Button
                          className="btn btn_man mt-3"
                          onClick={handleSubmit}
                          disabled={btnDisabled}
                        >
                          Add
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/* List */}
                  <div className="col-md-8">
                    <div className="whitelist_scrool whilist-right-main">
                      {addressData?.data?.length > 0 ? (
                        addressData.data.map((item) => (
                          <div key={item.id} className="whitelist-data">
                            <div className="white-top d-flex justify-content-between">
                              <div>
                                <h5>{item.symbol}</h5>
                              </div>
                              <div>
                                <h5>{item.name}</h5>
                              </div>
                            </div>
                            <div className="white-bottom d-flex justify-content-between">
                              <div className="wbba">{item.wallet_address}</div>
                              <div>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => handleDelete(item.id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No addresses whitelisted.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentMeta>
    </div>
  );
};

export default WhitelistFunction;
